import { render, staticRenderFns } from "./ResTitle.vue?vue&type=template&id=18a66baf&scoped=true&"
import script from "./ResTitle.vue?vue&type=script&lang=ts&"
export * from "./ResTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ResTitle.vue?vue&type=style&index=0&id=18a66baf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a66baf",
  null
  
)

export default component.exports